import React, { Component, Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import classNames from 'classnames';
import { pageCount } from '@devexpress/dx-grid-core';
import PaginationController from './PaginationContoller';
import PageSelector from './PageSelector';

const styles = theme => ({
    pagingContainer: {
        flex: "none",
        padding: "12px",
        display: "flex",
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    rowsLabel: {
        color: "rgba(0, 0, 0, 0.54)",
        fontSize: "1.3rem",
        fontWeight: "400",
        fontFamily: "Roboto",
        lineHeight: "1.375em",
        paddingRight: "40px"
    },
    pageSizeSelector: {
        color: "rgba(0, 0, 0, 0.54)",
        display: "flex",
        fontSize: "1.3rem",
        fontWeight: "400",
        fontFamily: "Roboto",
        lineHeight: "1.375em",
        alignItems: "center",
        paddingRight: "30px"
    },
    pagination: {},
    paginationController: {},
    pageSelector: {
        margin: "0 10px"
    }
});
class CustomPagingPanel extends PureComponent {
    render() {
        let { pageSizes, pageSize, onChangePageSize, classes, currentPage, totalCount, onCurrentPageChange } = this.props;
        return (
            <div className={classNames(classes.pagingContainer)}>
                <div className={classNames(classes.pageSizeSelector)}>
                    <span style={{ paddingRight: "24px" }}>
                        Rows per page:
                    </span>
                    <div style={{ fontSize: "14px", textAlign: "right" }}>
                        <Select
                            value={pageSize}
                            onChange={(e) => { onChangePageSize(e.target.value) }}
                        >
                            {pageSizes.map((pSize, idx) => {
                                return (
                                    <MenuItem key={idx} value={pSize}>{pSize}</MenuItem>
                                );
                            })}
                        </Select>
                    </div>
                </div>
                <div className={classNames(classes.pageSelector)}>
                    <PageSelector
                        currentPage={currentPage}
                        onCurrentPageChange={onCurrentPageChange}
                        classes={classes}
                    />
                </div>
                <div className={classNames(classes.pagination)}>
                    <PaginationController
                        totalPages={pageCount(totalCount, pageSize)}
                        currentPage={currentPage}
                        totalCount={totalCount}
                        pageSize={pageSize}
                        classes={classes}
                        onCurrentPageChange={onCurrentPageChange}
                    />
                </div>
            </div>
        )
    }
}

CustomPagingPanel.propTypes = {
    pageSizes: PropTypes.array.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalCount: PropTypes.number,
    classes: PropTypes.object.isRequired,
    currentPage: PropTypes.number.isRequired,
    onCurrentPageChange: PropTypes.func.isRequired
};

export default withStyles(styles)(CustomPagingPanel);


// WEBPACK FOOTER //
// ./src/main/content/common/data-table/CustomPagingPanel.js